import { Component } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';

import { UserService } from '../../services/user.service';
import { ApplicationService } from '../../services/application.service';
import { CompanyService } from '../../services/company.service';

import { MessageListItem } from '../../models/application';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  private _handleError: HandleError;
  private _logging = environment.logging;

  // isBrowserIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  userFullName = '';
  participantIdString = '';
  participantId: number = null;

  showWelcomeMessagesSpinner = false;
  showInstructionMessagesSpinner = false;
  showTemporaryMessagesSpinner = false;
  showGeneralMessagesSpinner = false; //01/10/2023 - 1098-E Message
  showSchoolLoanProgramMessageSpinner = false;

  welcomeMessageList: MessageListItem[] = [];
  instructionMessageList: MessageListItem[] = [];
  temporaryMessageList: MessageListItem[] = [];
  generalMessageList: MessageListItem[] = []; //01/10/2023 - 1098-E Message
  schoolLoanProgramMessageList: MessageListItem[] = [];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _errorHandler: ErrorHandler,
    private _userService: UserService,
    private _applicationService: ApplicationService,
    private _companyService: CompanyService,
    public media: MediaObserver
  ) {
    this._handleError = _errorHandler.createHandleError('HomeComponent');

    this.userFullName = this._userService.getFullName();
    this.participantId = this._userService.getParticipantId();
    this.participantIdString = this.participantId.toString();

    this.getData();
    this.scrollToTop();
  }

  getData(): void {
    const companyCode: string = this._companyService.getCompanyCode();
    const participantId: number = this._userService.getParticipantId();

    this.showWelcomeMessagesSpinner = true;
    this.getWelcomeMessageList(companyCode);

    if (participantId !== null) {
      this.showInstructionMessagesSpinner = true;
      this.getInstructionMessageList(participantId);
    }

    this.showTemporaryMessagesSpinner = true;
    this.getTemporaryMessageList(companyCode);

    //01/10/2023 - 1098-E Message
    this.showGeneralMessagesSpinner = true;
    this.getGeneralMessageList(companyCode);

    if (participantId !== null) {
      this.showSchoolLoanProgramMessageSpinner = true;
      this.getSchoolLoanProgramMessageList(participantId);
    }
  }

  getWelcomeMessageList(companyCode: string): void {
    this.showWelcomeMessagesSpinner = true;
    this._applicationService.getWelcomeMessageList(companyCode).subscribe(
      resultArray => {
        this.welcomeMessageList = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('HomeComponent.getWelcomeMessageList :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('HomeComponent.getWelcomeMessageList :: result = ' + JSON.stringify(resultArray));
        }
        this.showWelcomeMessagesSpinner = false;
      },
      error => this._handleError('getWelcomeMessageList', error)
    );
  }

  getInstructionMessageList(participantId: number): void {
    this.showInstructionMessagesSpinner = true;
    this._applicationService.getInstructionMessageList(participantId).subscribe(
      resultArray => {
        this.instructionMessageList = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('HomeComponent.getInstructionMessageList :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('HomeComponent.getInstructionMessageList :: result = ' + JSON.stringify(resultArray));
        }
        this.showInstructionMessagesSpinner = false;
      },
      error => this._handleError('getInstructionMessageList', error)
    );
  }

  getTemporaryMessageList(companyCode: string): void {
    this.showTemporaryMessagesSpinner = true;
    this._applicationService.getTemporaryMessageList(companyCode).subscribe(
      resultArray => {
        this.temporaryMessageList = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('HomeComponent.getTemporaryMessageList :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('HomeComponent.getTemporaryMessageList :: result = ' + JSON.stringify(resultArray));
        }
        this.showTemporaryMessagesSpinner = false;
      },
      error => this._handleError('getTemporaryMessageList', error)
    );
  }

  //01/10/2023 - 1098-E Message
  getGeneralMessageList(companyCode: string): void {
    this.showGeneralMessagesSpinner = true;
    this._applicationService.getGeneralMessageList(companyCode,"generalHome").subscribe(
      resultArray => {
        this.generalMessageList = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('HomeComponent.getGeneralMessageList :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('HomeComponent.getGeneralMessageList :: result = ' + JSON.stringify(resultArray));
        }
        this.showGeneralMessagesSpinner = false;
      },
      error => this._handleError('getGeneralMessageList', error)
    );
  }

  getSchoolLoanProgramMessageList(participantId: number): void {
    this.showSchoolLoanProgramMessageSpinner = true;
    this._applicationService.getSchoolLoanProgramMessageList(participantId).subscribe(
      resultArray => {
        this.schoolLoanProgramMessageList = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('HomeComponent.getSchoolLoanProgramMessageList :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('HomeComponent.getSchoolLoanProgramMessageList :: result = ' + JSON.stringify(resultArray));
        }
        this.showSchoolLoanProgramMessageSpinner = false;
      },
      error => this._handleError('getSchoolLoanProgramMessageList', error)
    );
  }

  getMessageCssClass(item: MessageListItem): string {
    return this._applicationService.getMessageListItemDisplayClass(item);
  }

  openPayNow(): void {
    if (this._logging.navigationTraceLog) {
      console.log('HomeComponent.openPayNow');
    }
    this._router.navigate(['paynow']);
  }

  openAutoPay(): void {
    if (this._logging.navigationTraceLog) {
      console.log('HomeComponent.openAutoPay');
    }
    this._router.navigate(['autopay']);
  }

  openLoanDetails(): void {
    if (this._logging.navigationTraceLog) {
      console.log('HomeComponent.openLoanDetails');
    }
    this._router.navigate(['loandetails']);
  }

  openEsignDetails(): void {
    if (this._logging.navigationTraceLog) {
      console.log('HomeComponent.openEsignDetails');
    }
    this._router.navigate(['esigndetails']);
  }

  scrollToTop() {
    const contentStart = document.getElementsByClassName('mat-sidenav-content');
    if (contentStart.length > 0) {
      contentStart[0].scrollTop = 0;
    }
  }

  openRoute(route: string): void {
    console.log('openRoute: ' + route);
  }
}
